import { useCallback, useMemo } from 'react';
import useTonConnect from './useTonConnect';

export const useTonTransaction = () => {
  const {
    wallet,
    address,
    isConnected,
    isReady,
    connect,
    disconnect,
    sendTransaction,
    getWalletAddress,
  } = useTonConnect();

  const ensureWalletConnection = useCallback(
    async (options) => {
      const result = await connect(options);
      return result;
    },
    [connect],
  );

  const executeTransaction = useCallback(
    async (transaction, options) => {
      const response = await sendTransaction(transaction, options);
      return response;
    },
    [sendTransaction],
  );

  const resolvedAddress = useMemo(() => {
    if (address) {
      return address;
    }
    return getWalletAddress();
  }, [address, getWalletAddress]);

  const extractAddress = useCallback(
    (walletCandidate) => getWalletAddress(walletCandidate),
    [getWalletAddress],
  );

  return {
    wallet,
    walletAddress: resolvedAddress,
    isConnected,
    isReady,
    ensureWalletConnection,
    executeTransaction,
    disconnect,
    getWalletAddress: extractAddress,
  };
};

export default useTonTransaction;

